"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zh = void 0;
const zh = exports.zh = {
  Announcements: {
    LoadError: '未能载入公告',
    NoAnnouncements: '目前没有可显示的公告',
    Title: 'ICIS公告',
    Type: {
      Correction: '更正通知',
      FinalizedPrice: '最终价格通知',
      Global: '全球通知',
      Report: '报告通知'
    }
  },
  General: {
    Cancel: '取消',
    Close: '关闭',
    Error: '一般错误',
    Menu: '菜单',
    Reload: '重新加载',
    Search: '搜索'
  },
  HeaderMenus: {
    Analytics: {
      CarbonAnalytics: '碳分析',
      LngAnalytics: 'LNG分析',
      PowerAnalytics: '电力分析',
      Energy: {
        GroupName: '能源',
        CarbonForesight: '碳预测与分析',
        EULTPower: '欧洲远期电力分析',
        Gas: '天然气预测与分析',
        HydrogenPricing: '氢能源价格及分析',
        LNG: 'LNG预测与分析',
        PowerForesight: '电力预测',
        PowerShortTermForecast: '电力短期预测'
      },
      Chemicals: {
        GroupName: '化工品',
        LiveDisruptionsTrackerImpact: '实时中断追踪 - 影响',
        LiveDisruptionsTrackerSupply: '实时中断追踪 - 供应',
        MarginAnalytics: '利润分析',
        SupplierCarbonFootprints: '供应商碳足迹',
        SupplyAndDemand: '供需数据库'
      },
      Recycling: {
        GroupName: '回收',
        RPETPricingAndAnalytics: 'R-PET 价格和分析',
        RecyclingSupplyTrackerChemical: '回收供应追踪——化学回收',
        RecyclingSupplyTrackerMechanical: '回收供应追踪——机械回收'
      },
      Refining: {
        GroupName: '炼厂',
        ChinaRefinery: '中国炼厂运行分析'
      }
    },
    Commodities: {
      AllSubscribed: '所有订阅品目',
      Favourites: '收藏',
      Filter: '筛选',
      NoMatches: '未找到匹配结果',
      NoSubscribedCommodities: '您尚未订阅任何品目主页。'
    },
    Contact: {
      Contact: '联系我们',
      Email: '邮件',
      LiveChat: '实时聊天',
      Phone: '电话',
      Telephone: '电话联系'
    },
    Help: {
      Credits: '积分帮助',
      IcisServicesHelp: '安迅思服务帮助',
      IcisSupportHub: 'ICIS服务支持中心',
      Methodology: '方法论',
      PlatformTraining: '平台培训',
      PublishingSchedule: '发布时间表'
    },
    LoadError: '未能载入导航栏',
    Main: {
      Analytics: '分析',
      Commodities: '品目',
      Contact: '联系我们',
      CreditsUsage: '积分使用情况:',
      CreditReportFinder: '信用分报告查询',
      Dashboard: 'Dashboard',
      Home: '主页',
      IntelligencePages: '主题',
      NewHome: '新主页',
      News: '行业资讯',
      ToolsAndServices: '工具&服务',
      WebminarCalendars: 'Live Webinars'
    },
    News: {
      AdvancedSearch: '高级搜索',
      LatestNews: '最新行业资讯',
      Magazine: '杂志',
      MySavedArticles: '已保存文章',
      MySavedSearches: '已保存搜索结果',
      NewsChanEnergyFocus: '能源焦点',
      NewsChanInsightAnalysis: '洞察和分析',
      NewsChanLatest: '最新行业资讯',
      NewsChanMagazine: '专题通讯',
      NewsChanOverview: '首页',
      NewsChanSavedSearches: '已保存搜索',
      RssFeeds: 'RSS订阅',
      ReadingList: '阅读清单',
      AlertsAndSettings: '行业快讯'
    },
    Profile: {
      ChangePassword: '更改密码',
      CookiePolicy: 'Cookie政策',
      Logout: '退出登录',
      MyPreferences: '我的偏好',
      PrivacyPolicy: '隐私政策',
      TermsAndConditions: '条款和协议'
    },
    ToolsAndServices: {
      Alerts: '快讯',
      ApiDataAccess: 'API数据访问',
      CommodityAlerts: '品目快讯',
      Conferences: '会议',
      Consultancy: '咨询',
      Credits: '积分使用情况: ',
      CreditReportFinder: '信用分报告查询',
      DownloadApp: 'ICIS App',
      ExcelPlugin: 'Excel插件',
      ExchangeRates: 'XE.com汇率',
      ExploreAllServices: '探索ICIS产品和服务',
      LiveDisruptionsImpact: '实时中断追踪 - 影响',
      LiveDisruptionsSupply: '实时中断追踪 - 供应',
      Lsdt: '实时供应中断',
      MarginAnalytics: '利润分析',
      PriceOptimisation: '价格优化',
      RPET: '再生PET数据',
      SupplyAndDemand: '供需数据库',
      Training: '培训',
      Tools: '工具',
      Services: '服务'
    }
  },
  NavIconAccessibilityText: {
    announcements: '公告',
    help: '帮助',
    search: '搜索',
    user: '隐私'
  },
  RequestTool: {
    unlockData: '解锁数据',
    notifyUs: '通知我们',
    requestAccess: '申请访问',
    requestSent: '已发送请求',
    requestFailed: '请求失败',
    done: '完成',
    receiveData: {
      success: '您的客户经理将与您联系，讨论下一步行动',
      errorTittle: '当前无法完成您的请求。',
      errorSubTitle: '请稍后再试。'
    }
  }
};